module.exports = __webpack_public_path__ + "static/img/hot.7e056c50.png";